import classNames from "classnames";
import { camelCase } from "lodash";
import React, { useContext } from "react";
import { RicosNodeContext, RicosViewerContext } from "./../../../../../ricos-context";
import { Node_Type } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1";
import {
  addAnchorTagToUrl,
  anchorScroll,
  convertRelObjectToString,
  normalizeHref
} from "./../../../../../wix-rich-content-common";
import { getPaywallSeoClass, isPaywallSeo } from "../../utils/paywallSeo";
const disableCustomWidthMapper = {
  [Node_Type.IMAGE]: (componentData, isMobile) => componentData?.image?.width && isMobile && (componentData?.containerData?.width?.custom || 0) > 150
};
const isMediumOrFullWidth = (containerData) => {
  return containerData?.width?.size && (containerData.width.size === "CONTENT" || containerData.width?.size === "FULL_WIDTH");
};
const originalSizeMapper = {
  [Node_Type.IMAGE]: (componentData) => isMediumOrFullWidth(componentData.containerData) ? "100%" : `${componentData?.image?.width}px`,
  [Node_Type.GIF]: (componentData) => isMediumOrFullWidth(componentData.containerData) ? "100%" : `${componentData.width}px`
};
const ContainerElement = ({
  node,
  nodeIndex,
  context,
  className,
  children
}) => {
  const { customAnchorScroll } = useContext(RicosViewerContext);
  const { parentNode } = useContext(RicosNodeContext);
  const dataProperty = `${camelCase(node.type)}Data`;
  const { seoMode, anchorTarget, isMobile } = context;
  const { link, containerData } = node[dataProperty] || {};
  const wrapInLink = link && node.type !== Node_Type.BUTTON;
  const Tag = wrapInLink ? "a" : "div";
  const disableCustomWidth = disableCustomWidthMapper[node.type]?.(node[dataProperty], isMobile);
  const customWidth = containerData?.width?.custom && !disableCustomWidth ? `${isNaN(Number(containerData.width.custom)) ? containerData.width.custom : parseInt(containerData.width.custom)}px` : void 0;
  const originalWidth = originalSizeMapper[node.type]?.(node[dataProperty]);
  const width = customWidth || originalWidth;
  const style = containerData && width ? {
    width: `min(100%, ${width})`
  } : void 0;
  const urlHref = link?.url && normalizeHref(link.url);
  const anchorHref = link?.anchor;
  const viewerAnchorHref = anchorHref ? `#viewer-${anchorHref}` : void 0;
  const linkProps = wrapInLink ? {
    href: urlHref ?? viewerAnchorHref,
    target: link.target ? `_${link.target.toLowerCase()}` : anchorTarget,
    rel: link.rel && convertRelObjectToString(link.rel),
    onClick: anchorHref ? (e) => {
      if (customAnchorScroll) {
        return customAnchorScroll(e, anchorHref);
      }
      const anchorRefId = `viewer-${anchorHref}`;
      const element = document.getElementById(anchorRefId);
      if (!element) {
        return;
      }
      addAnchorTagToUrl(anchorRefId);
      anchorScroll(element);
    } : void 0
  } : {};
  return /* @__PURE__ */ React.createElement(
    Tag,
    {
      className: classNames(
        className,
        !parentNode && isPaywallSeo(seoMode) && getPaywallSeoClass(seoMode?.paywall || {}, nodeIndex)
      ),
      style,
      ...linkProps
    },
    children
  );
};
export {
  ContainerElement
};
//# sourceMappingURL=ContainerElement.js.map
